var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1976",
    "data-name": "Group 1976",
    transform: "translate(0.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3182",
    "data-name": "Rectangle 3182",
    width: 28,
    height: 28,
    rx: 5,
    transform: "translate(-0.2 0)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-pop-up-2186785",
    transform: "translate(6.38 6.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8986",
    "data-name": "Path 8986",
    d: "M317.305,53.015h-5.08v-5.08a1.27,1.27,0,0,0-2.54,0v5.08H304.6a1.27,1.27,0,0,0,0,2.54h5.08v5.08a1.27,1.27,0,0,0,2.54,0v-5.08h5.08a1.27,1.27,0,0,0,0-2.54Z",
    transform: "translate(-303.335 -46.665)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8e5afe85d6bcc944c2990175f00065cf.svg";
export { ForwardRef as ReactComponent };